import React, { useState } from 'react'
import Fabric from './Fabric'

const curtainData = [
  {
    id: 1,
    title: 'Budget Blackout',
    desc: 'These fabrics provide 100% light blockage, enhancing privacy, sleep quality, and energy efficiency, ideal for curtains or blinds.',
    link: '/shop',
    primaryImage: 'fabric-1-main',
    secondaryImage: 'fabric-1-supportive',
  },
  {
    id: 2,
    title: 'Locomotion',
    desc: 'Eco-friendly sheer fabrics crafted from recycled polyester, offering understated elegance.',
    link: '/shop',
    primaryImage: 'fabric-2-main',
    secondaryImage: 'fabric-2-supportive',
  },
  {
    id: 3,
    title: 'Serene Sheers',
    desc: 'Sheer fabrics with understated weaves and a soothing neutral palette, offering a timeless blend of texture and translucency.',
    link: '/shop',
    primaryImage: 'fabric-1-main',
    secondaryImage: 'fabric-1-supportive',
  },
  {
    id: 4,
    title: 'Satina',
    desc: 'Sophisticated wide-width voile sheers in soothing neutrals and pastels, offering delicate transparency, eco-friendly design, and timeless elegance.',
    link: '/shop',
    primaryImage: 'fabric-2-main',
    secondaryImage: 'fabric-2-supportive',
  },
  {
    id: 5,
    title: 'MATTE JACQUARDS II',
    desc: 'Crafted from recycled yarns, this eco-conscious collection epitomizes style and elegance.',
    link: '/shop',
    primaryImage: 'fabric-1-main',
    secondaryImage: 'fabric-1-supportive',
  },
  {
    id: 6,
    title: 'LUSTRE',
    desc: 'Luxurious satin fabrics with a lustrous sheen and fluid drape, offering sophisticated neutrals for elegant, refined drapery.',
    link: '/shop',
    primaryImage: 'fabric-2-main',
    secondaryImage: 'fabric-2-supportive',
  },
  {
    id: 7,
    title: 'ECO BOUCLE SHEERS',
    desc: 'Eco-friendly boucl sheers in soft neutrals, combining sustainable style with a serene ambiance and refined texture.',
    link: '/shop',
    primaryImage: 'fabric-1-main',
    secondaryImage: 'fabric-1-supportive',
  },
  {
    id: 8,
    title: 'NATURAL JACQUARDS',
    desc: 'Eco-friendly dry-look jacquard curtains in neutral shades, featuring contemporary patterns and abstract texture.',
    link: '/shop',
    primaryImage: 'fabric-2-main',
    secondaryImage: 'fabric-2-supportive',
  },
  {
    id: 9,
    title: 'Budget Blackout',
    desc: 'These fabrics provide 100% light blockage, enhancing privacy, sleep quality, and energy efficiency, ideal for curtains or blinds.',
    link: '/shop',
    primaryImage: 'fabric-1-main',
    secondaryImage: 'fabric-1-supportive',
  },
  {
    id: 10,
    title: 'Locomotion',
    desc: 'Eco-friendly sheer fabrics crafted from recycled polyester, offering understated elegance.',
    link: '/shop',
    primaryImage: 'fabric-2-main',
    secondaryImage: 'fabric-2-supportive',
  },
  {
    id: 11,
    title: 'Serene Sheers',
    desc: 'Sheer fabrics with understated weaves and a soothing neutral palette, offering a timeless blend of texture and translucency.',
    link: '/shop',
    primaryImage: 'fabric-1-main',
    secondaryImage: 'fabric-1-supportive',
  },
  {
    id: 12,
    title: 'Satina',
    desc: 'Sophisticated wide-width voile sheers in soothing neutrals and pastels, offering delicate transparency, eco-friendly design, and timeless elegance.',
    link: '/shop',
    primaryImage: 'fabric-2-main',
    secondaryImage: 'fabric-2-supportive',
  },
  {
    id: 13,
    title: 'MATTE JACQUARDS II',
    desc: 'Crafted from recycled yarns, this eco-conscious collection epitomizes style and elegance.',
    link: '/shop',
    primaryImage: 'fabric-1-main',
    secondaryImage: 'fabric-1-supportive',
  },
  {
    id: 14,
    title: 'LUSTRE',
    desc: 'Luxurious satin fabrics with a lustrous sheen and fluid drape, offering sophisticated neutrals for elegant, refined drapery.',
    link: '/shop',
    primaryImage: 'fabric-2-main',
    secondaryImage: 'fabric-2-supportive',
  },
  {
    id: 15,
    title: 'ECO BOUCLE SHEERS',
    desc: 'Eco-friendly boucl sheers in soft neutrals, combining sustainable style with a serene ambiance and refined texture.',
    link: '/shop',
    primaryImage: 'fabric-1-main',
    secondaryImage: 'fabric-1-supportive',
  },
  {
    id: 16,
    title: 'NATURAL JACQUARDS',
    desc: 'Eco-friendly dry-look jacquard curtains in neutral shades, featuring contemporary patterns and abstract texture.',
    link: '/shop',
    primaryImage: 'fabric-2-main',
    secondaryImage: 'fabric-2-supportive',
  },
]

function Product({ data }) {

  const [showAll, setShowAll] = useState(false)

  const showMoreFabrics = () => {
    setShowAll(prev => !prev)
  }

  const visibleFabrics = showAll ? data : data.slice(0, 8)


  return (
    <div className='lyt-fabrication-list__info-wrap'>
      <ul className='lyt-fabrication-list__list-wrap'>
        {visibleFabrics.map((item, index) => {
          return (
            <li className='lyt-fabrication-list__list-item' key={index}>
              <Fabric
                title={item?.collection_name}
                desc={item?.coll_description}
                link={`/collection-detail/${item?.slug?.toLowerCase()}`}
                mainImage={item?.coll_image[0]}
                supportingImage={item?.coll_image[1]}
              />
            </li>
          )
        })}
      </ul>
      {data.length > 8 && (
        <div className='lyt-fabrication-list__action-wrap'>
          <button className={`bs-btn bs-btn__btn-capsule ${showAll ? 'bs-btn__btn-capsule--visited' : ''}`} onClick={showMoreFabrics}>
            <span className='bs-btn__btn-text'>view {showAll ? 'less' : 'more'}</span>
            <span className='bs-btn__icon icon icon-down'></span>
          </button>
        </div>
      )}
    </div>
  )
}

export default Product